import { render, staticRenderFns } from "./DashboardFull.vue?vue&type=template&id=ca2a9644"
import script from "./DashboardFull.vue?vue&type=script&lang=js"
export * from "./DashboardFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports